module.exports = __webpack_public_path__ + "static/section5-553de6da44d984ea53b0b4be1e63a286.svg";